import React from 'react';
import {
  filterFormStyle, filterRowStyle, filterLabelStyle, filterInputStyle,
  btnPrimaryStyle, btnSecondaryStyle,
} from './styles';
import { isQuickFilterActive, QUICK_FILTERS } from './businessLogFilterConfig';

const quickFilterRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 7,
  marginBottom: 10,
};

// 활성 = 디자인 표준 알약 톤(연파랑 배경 + 파랑 글씨, 색 테두리 없음)
const quickFilterButtonStyle = (active) => ({
  height: 28,
  padding: '0 10px',
  borderRadius: 999,
  border: `1px solid ${active ? 'transparent' : 'var(--border)'}`,
  background: active ? 'var(--std-pill-on-bg, rgba(59,154,242,0.12))' : 'var(--bg-subtle)',
  color: active ? 'var(--std-pill-on-text, #1d7de6)' : 'var(--text-sub)',
  fontSize: 11,
  fontWeight: 800,
  cursor: 'pointer',
});

export default function BusinessLogFilters({
  filters,
  sources,
  actions,
  companies,
  onChange,
  onQuickFilter,
  onSearch,
  onReset,
}) {
  return (
    <form onSubmit={onSearch} style={{ ...filterFormStyle, marginBottom: 12 }}>
      <div style={quickFilterRowStyle} aria-label="빠른 필터">
        {QUICK_FILTERS.map((item) => {
          const active = isQuickFilterActive(item.key, filters);
          return (
            <button
              key={item.key}
              type="button"
              style={quickFilterButtonStyle(active)}
              onClick={() => onQuickFilter(item.key)}
            >
              {item.label}
            </button>
          );
        })}
      </div>
      <div style={filterRowStyle}>
        <label style={filterLabelStyle}>
          월
          <input
            type="month"
            style={{ ...filterInputStyle, width: 126 }}
            value={filters.month}
            onChange={(e) => onChange('month', e.target.value)}
          />
        </label>
        <label style={filterLabelStyle}>
          회사
          <select
            style={{ ...filterInputStyle, width: 104 }}
            value={filters.company}
            onChange={(e) => onChange('company', e.target.value)}
          >
            <option value="">전체</option>
            {companies.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
          </select>
        </label>
        <label style={filterLabelStyle}>
          직원
          <input
            style={{ ...filterInputStyle, width: 130 }}
            value={filters.person}
            onChange={(e) => onChange('person', e.target.value)}
            placeholder="이름/아이디"
          />
        </label>
        <label style={filterLabelStyle}>
          메뉴
          <select
            style={{ ...filterInputStyle, width: 154 }}
            value={filters.source}
            onChange={(e) => onChange('source', e.target.value)}
          >
            <option value="">전체</option>
            {sources.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
          </select>
        </label>
        <label style={filterLabelStyle}>
          행동
          <select
            style={{ ...filterInputStyle, width: 116 }}
            value={filters.action}
            onChange={(e) => onChange('action', e.target.value)}
          >
            {actions.map((item) => <option key={item.value || 'all'} value={item.value}>{item.label}</option>)}
          </select>
        </label>
        <label style={filterLabelStyle}>
          검색
          <input
            style={{ ...filterInputStyle, width: 190 }}
            value={filters.search}
            onChange={(e) => onChange('search', e.target.value)}
            placeholder="대상, 변경내용"
          />
        </label>
        <label style={filterLabelStyle}>
          시작일
          <input
            type="date"
            style={{ ...filterInputStyle, width: 130 }}
            value={filters.dateFrom}
            onChange={(e) => onChange('dateFrom', e.target.value)}
          />
        </label>
        <label style={filterLabelStyle}>
          종료일
          <input
            type="date"
            style={{ ...filterInputStyle, width: 130 }}
            value={filters.dateTo}
            onChange={(e) => onChange('dateTo', e.target.value)}
          />
        </label>
        <button type="submit" style={btnPrimaryStyle}>조회</button>
        <button type="button" style={btnSecondaryStyle} onClick={onReset}>초기화</button>
      </div>
    </form>
  );
}
